export enum ModuleConnections {
  left= 1,
  left_1= 2,
  left_2= 3,
  center= 4,
  right= 5,
  right_1= 6,
  right_2= 7,
  left_3 = 8,
  right_3 = 9,
  none = -1,
  support = 0
}
